import { Img } from '@chakra-ui/image';
import { Box, Center, Circle, Flex, Text } from '@chakra-ui/layout';
import { Textarea } from '@chakra-ui/textarea';
import React, { useEffect, useRef, useState } from 'react';
import RecievedMessage from './RecievedMessage';
import SentMessage from './SentMessage';
import sendIcon from '../../Assets/SendIcon.png';
import Message from './SentMessage';
import { socket } from '../../socket';
import { data, getRecruiters, students } from './contants';
import { getSingleUser } from 'services/api';
import { useWindow } from 'hooks/useWindow';
import arrow from 'Assets/arrowLeft.svg';
// import { useParams } from "react-router-dom";
const ChatBox = ({ type, id, mobileView, setMobileView }) => {
  const [chats, allChats] = useState([]);
  const windowSize = useWindow();
  const [user, setUser] = useState({});
  const [isfetch, setFetch] = useState(false);
  const [message, setMessage] = useState('');
  const [singleChat, setSingleChat] = useState([]);
  const [userChats, setUserChats] = useState([]);
  const chatBoxRef = useRef(null);
  const profile = JSON.parse(localStorage.getItem('user'));
  const fetchUser = async () => {
    try {
      const { data } = await getSingleUser(id);
      setUser(data.data[0]);
    } catch (e) {
      console.log(e);
    }
  };
  let room;
  if (profile?.profile === 'ajna_student') {
    room = profile?._id + '_' + id;
  } else {
    room = id + '_' + profile?._id;
  }

  useEffect(() => {
    if (id) {
      fetchUser();
    }
    const name = profile.name + '_' + type;
    socket.emit('login', { name, room }, (err) => {
      if (err) {
        return;
      } else {
      }
    });
  }, [id]);

  //   socket.on("message", function (data) {
  //     allChats([...chats, data]);
  //   });
  useEffect(() => {
    socket.on('historical_messages', function (messages) {
      allChats(messages);
    });
    socket.on('message', function (data) {
      setSingleChat([
        ...singleChat,
        {
          message: data.text,
          username: data.user,
          ...data,
        },
      ]);
    });
  }, [isfetch, socket, id]);

  useEffect(() => {
    allChats(chats.concat(singleChat));
  }, [singleChat, id]);

  useEffect(() => {
    chatBoxRef?.current?.scrollTo({
      top: chatBoxRef.current.scrollHeight,
    });
    if (chats.length > 0) {
      const chatsArray = chats.map((chat) => {
        return {
          ...chat,
          timestamp: chat?.timestamp
            ? new Date(chat?.timestamp).toISOString()
            : new Date().toISOString(),
        };
      });
      let key = 'timestamp';
      const uniqueChats = [
        ...new Map(chatsArray.map((item) => [item[key], item])),
      ]
        .map((i) => i[1])
        .filter((i) => i.room === room);
      setUserChats(uniqueChats);
    }
  }, [chats]);

  const sendMessage = (e) => {
    const profile = JSON.parse(localStorage.getItem('user'));
    const chat = {
      message: message,
      room: room,
      username: profile.name + '_' + type,
      timestamp: new Date(),
    };
    const isBlank = /^\s*$/.test(message);
    if (isBlank) {
      return;
    }
    socket.emit("message", chat);
    allChats([...chats, chat]);
    setFetch(!isfetch);
    setMessage('');
  };



  return (
    <div>
      <Box
        w={mobileView?.chatList ? '50vw' : '100%'}
        h={'80%'}
        // borderLeft={
        //   windowSize > 500 && mobileView?.chatList && "1px solid #E4E4E4"
        // }
        className={
          !mobileView?.chatList && !mobileView?.profile ? '' : 'mobile-d-none'
        }
      >
        {id && (
          <>
            {/* Header */}
            <Flex
              align={'center'}
              gap={4}
              p={3}
              height={'72px'}
              borderBottom='1px solid #E4E4E4'
            >
              <Flex overflow={'auto'}>
                {windowSize < 500 && (
                  <Img
                    src={arrow}
                    width={30}
                    mr={2}
                    onClick={() => {
                      setMobileView({
                        ...mobileView,
                        chatList: true,
                      });
                    }}
                  />
                )}
                <Img
                  h={51}
                  w={51}
                  borderRadius={'50%'}
                  src={user?.image}
                  alt='pic'
                />
              </Flex>
              <Box
                onClick={() =>
                  windowSize < 500 &&
                  setMobileView((state) => {
                    return {
                      ...state,
                      chatList: false,
                      profile: true,
                    };
                  })
                }
              >
                {/* name */}
                <Text
                  fontSize={18}
                  fontFamily='Roboto'
                  fontWeight={600}
                  textAlign={'left'}
                >
                  {user?.name || 'Tester'}
                </Text>
                <Text fontSize={16} textAlign={'left'}>
                  {user?.jobTitle}
                </Text>
              </Box>
            </Flex>
            <Box
              py={6}
              overflowY={'auto'}
              h={'85%'}
              overflowX={'hidden'}
              ref={chatBoxRef}
              className='scrollbar-none'
            >
              {type === 'recruiter' && <SentMessage chats={userChats} />}
              {type === 'student' && <RecievedMessage chats={userChats} />}
              {/* <Flex justify={"left"}>
            <RecievedMessage chats={chats} />
          </Flex> */}
            </Box>
          </>
        )}
        {!id && (
          <Center h={'100%'} w={'100%'}>
            <Text fontSize={20} fontFamily={'Roboto'}>
              Select a user to start chat
            </Text>
          </Center>
        )}
      </Box>

      {/* Message Box */}
      {id && (
        <Flex
          padding={5}
          className={
            !mobileView?.chatList && !mobileView?.profile ? '' : 'mobile-d-none'
          }
          align={'center'}
          w={'100%'}
          borderTop={'1px solid #E4E4E4'}
          gap={4}
        >
          <Textarea
            fontSize={20}
            fontFamily={'Roboto'}
            paddingX={10}
            py={5}
            className='textarea-chatbox'
            style={{
              resize: 'none',
            }}
            placeholder={'Write Message here...'}
            value={message}
            onKeyDown={(e) => e.keyCode === 13 && sendMessage()}
            onChange={(e) => setMessage(e.target.value)}
            h={10}
            border={'1px solid'}
            borderRadius={12}
          />
          <Circle
            size={12}
            border='1px solid #DDDDDD'
            onClick={sendMessage}
            className='cursor'
          >
            <Img src={sendIcon} alt='send' />
          </Circle>
        </Flex>
      )}
    </div>
  );
};

export default ChatBox;
